import React, { useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, Trash2, PenLine, Info } from "lucide-react";
import { noImg } from '@/assets';
import { DeleteConfirmDialog, ImageDialog } from '@/components/dialog/common-dialog';
import { useDispatch, useSelector } from 'react-redux';
import { deleteNoticeById, updateToggleNotice } from '@/redux/slice/order-ordering-slice/notice-slice';
import { toast } from "react-hot-toast";
import { Switch } from '@/components/ui/switch';
import { Link } from 'react-router-dom';
import ViewNotice from './ViewNotice';

const AllNoticeTable = ({notices}) => {
	const dispatch = useDispatch();
	const [imageDialog, setImageDialog] = useState(false);
	const [variantDetails, setVarianDetails] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [itemsDialog, setItemsDialog] = useState(null);
	const { deleteLoading, requestStatus, error} = useSelector((state) => state.onlineOrdering.notice);
	const deleteHandler = async (id) => {
		try {
		  if (!id) {
			toast.error("ID is required to delete.");
			return;
		  }
		  await dispatch(deleteNoticeById(id));
		  if (requestStatus) {
			toast.success("Dish of the day deleted successfully!");
		  } else {
			toast.error(error);
		  }
		} catch (error) {
		  toast.error(error.message || "Something went wrong!.");
		} finally {
		  setDeleteDialog(false);
		}
	};

	const closeVarintDetails = () => {
		setVarianDetails(false);
		setItemsDialog(null);
	};

	const handleToggle = (id) => {
		dispatch(updateToggleNotice({id}))
	}
  return (
	<>
		<Table className="w-full mt-7">
			<TableHeader>
			<TableRow>
				<TableHead className="w-[100px]">Serial No</TableHead>
				<TableHead>Create Date</TableHead>
				<TableHead>Banner</TableHead>
				<TableHead>Message</TableHead>
				<TableHead>Status</TableHead>
				<TableHead className="text-right">Action</TableHead>
			</TableRow>
			</TableHeader>
			<TableBody>
			{notices && notices?.length > 0 ? (
				notices?.map((item, index) => (
				<TableRow key={index}>
					<TableCell className="font-medium">
					{index+1}
					</TableCell>
					<TableCell>
						{new Date(item?.created_at).toLocaleDateString("en-GB", {
							day: "2-digit",
							month: "2-digit",
							year: "2-digit",
						}) +
						" - " +
						new Date(item?.created_at).toLocaleTimeString("en-US", {
						hour: "2-digit",
						minute: "2-digit",
						hour12: true,
						}).toLowerCase()}
					</TableCell>
					<TableCell>
						<img
							onClick={() => {
								setImageDialog(true);
								setItemsDialog(item);
							}}
							className="h-8 rounded-md w-8 object-cover cursor-pointer"
							src={item?.file_manager_url || noImg}
							alt="Item Image"
						/>
					</TableCell>
					<TableCell className="font-medium max-w-[200px]">
						<span title={item.message}>
							{item.message?.length > 40
								? `${item.message.slice(0, 40)}...`
								: item.message}
						</span>
					</TableCell>
					<TableCell>
						{item?.status === true && (
							<span className="text-cgreen text-base">Active</span>
						)}
						{item?.status === false && (
							<span className="text-cred text-base">Archived</span>
						)}
					</TableCell>

					
					<TableCell className="text-right justify-end flex gap-2 items-center">
					<div className="flex items-center gap-2 h-8">
						<Eye
							onClick={() => {
								setVarianDetails(true);
								setItemsDialog(item);
							}}
							className="text-cwhite3 cursor-pointer"
							size={18}
						/>

						<span className="cursor-pointer">
							<Link to={"/onlineordering/settings/notice/update"} state={item}>
								<PenLine
									className="text-cyellow"
									size={18}
								/>
							</Link>
						</span>
						<Switch checked={item?.status} onClick={()=> handleToggle(item?.id)}/>

						<span>
							<Trash2
								onClick={() => {
									setDeleteDialog(true);
									setItemsDialog(item);
								}}
								className="text-cred cursor-pointer"
								size={18}
							/>
						</span>
					</div>
					</TableCell>
				</TableRow>
				))
			) : (
				<TableRow>
					<TableCell colSpan={8} className="text-center">
						No data available
					</TableCell>
				</TableRow>
			)}
			</TableBody>
		</Table>
		<DeleteConfirmDialog
			isLoading={deleteLoading}
			isOpen={deleteDialog}
			onClose={() => setDeleteDialog(false)}
			onConfirm={() => {
				deleteHandler(itemsDialog.id);
			}}
		/>
		<ViewNotice 
			items={itemsDialog}
			isOpen={variantDetails}
			onClose={closeVarintDetails}/>
		<ImageDialog
			items={itemsDialog}
			isOpen={imageDialog}
			onClose={() => setImageDialog(false)}
		/>
	</>
  )
}

export default AllNoticeTable